export default __webpack_public_path__ + "static/media/flight.a67dc3a6.svg";